import React from 'react';
/**
 * ModalLayer — Overlay modals for the main learner view
 *
 * Extracted from App.tsx in R34 (DDD Fase 6 — App Shell decomposition).
 * Renders all overlay modals: AssessmentRecoveryModal, ValidationErrorModal,
 * AssessmentErrorModal, ModulePanel, CheatSheetDrawer.
 */
import { AssessmentRecoveryModal, AssessmentErrorModal } from '../assessment';
import { ValidationErrorModal } from '../components/shared/ValidationErrorModal';
import { ModulePanel } from '../components/module/ModulePanel';
import { ModuleIntroDrawer } from '../components/module/ModuleIntroDrawer';
import { CheatSheetDrawer } from '../practice';
import type { ModuleId } from '../content';
import type { GroupId } from '../config/systemConfig';
import type { RecoverableSession } from '../assessment';
interface ModalLayerProps {
  // Assessment recovery
  recoverableSession: RecoverableSession | null;
  onResumeAssessment: () => void;
  onAbandonRecovery: () => void;
  // Validation error
  validationError: string | null;
  selectedGroup: GroupId;
  onCloseValidationError: () => void;
  onSwitchToGroup6: () => void;
  onNavigateToModules: () => void;
  // Assessment error
  assessmentError: string | null;
  onCloseAssessmentError: () => void;
  // Module panel
  selectedModule: {
    id: string;
    name: string;
    icon: string;
    color: string;
    description: string;
  } | null;
  moduleProgress: {
    cheatSheetViewed?: boolean;
    questionsAnswered?: number;
    correctAnswers?: number;
  } | null;
  onCloseModulePanel: () => void;
  onStartPractice: (moduleId: ModuleId) => void;
  onViewExplanation: (moduleId: string) => void;
  // Cheat sheet
  cheatSheetModuleId: ModuleId | null;
  onCloseCheatSheet: () => void;
  // Intro drawer
  introModuleId?: ModuleId | null;
  onCloseIntroDrawer?: () => void;
}
export function ModalLayer({
  recoverableSession,
  onResumeAssessment,
  onAbandonRecovery,
  validationError,
  selectedGroup,
  onCloseValidationError,
  onSwitchToGroup6,
  onNavigateToModules,
  assessmentError,
  onCloseAssessmentError,
  selectedModule,
  moduleProgress,
  onCloseModulePanel,
  onStartPractice,
  onViewExplanation,
  cheatSheetModuleId,
  onCloseCheatSheet,
  introModuleId,
  onCloseIntroDrawer
}: ModalLayerProps): React.ReactElement {
  return <>
      {recoverableSession && <AssessmentRecoveryModal session={recoverableSession} onResume={onResumeAssessment} onAbandon={onAbandonRecovery} data-id="element-792" />}

      {validationError && <ValidationErrorModal error={validationError} selectedGroup={selectedGroup} onClose={onCloseValidationError} onSwitchToGroup6={onSwitchToGroup6} onNavigateToModules={onNavigateToModules} data-id="element-793" />}

      {assessmentError && <AssessmentErrorModal message={assessmentError} onClose={onCloseAssessmentError} data-id="element-794" />}

      <ModulePanel isOpen={!!selectedModule} onClose={onCloseModulePanel} module={selectedModule} progress={moduleProgress} onStartPractice={moduleId => onStartPractice(moduleId as ModuleId)} onViewExplanation={onViewExplanation} selectedGroup={selectedGroup} data-id="element-795" />

      {cheatSheetModuleId && <CheatSheetDrawer isOpen={true} onClose={onCloseCheatSheet} moduleId={cheatSheetModuleId} data-id="element-796" />}

      {introModuleId && onCloseIntroDrawer && <ModuleIntroDrawer isOpen={true} onClose={onCloseIntroDrawer} moduleId={introModuleId} selectedGroup={selectedGroup} data-id="element-797" />}
    </>;
}